import { useState, useEffect } from 'react';

import MultiSelectProps from './type';
import Button from '../Button';
import Icon from '../Icon';
import { getUniqueKey } from '../utils';
import {
  MultiSelectWrapperStyled,
  MultiSelectButtonStyled,
  MultiSelectItemWrapperStyled,
  MultiSelectItemStyled,
  RadioButtonWrapper,
  RadioButton,
  IconWrapperMultiSelectAnimation,
  HandlersMultiSelectWrapper,
  MultiSelectBodyItemWrapperStyled,
} from './styled';

const MultiSelect = ({ ...props }: MultiSelectProps) => {
  const {
    disabled,
    open: openProps,
    placeholder,
    getOptionLabel,
    options,
    values: valuesProps = [],
    handleApply: handleApplyProps,
    handleCancel: handleCancelProps,
    ...rest
  } = props;
  const [open, setOpen] = useState(openProps || false);
  const [values, setValues] = useState(valuesProps || []);

  const handleChange = (newValue: string) => {
    if (values.includes(newValue)) {
      setValues(values.filter((item) => item !== newValue));
    } else {
      setValues([...values, newValue]);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setValues(valuesProps || []);
    if (handleCancelProps) handleCancelProps();
  };

  const handleApply = () => {
    setOpen(false);
    if (handleApplyProps) handleApplyProps(values);
  };

  useEffect(() => {
    if (valuesProps !== null) setValues(valuesProps);
  }, [valuesProps]);

  useEffect(() => {
    if (openProps !== null && !disabled) setOpen(openProps);
  }, [openProps]);

  return (
    <MultiSelectWrapperStyled disabled={disabled} {...rest}>
      <MultiSelectButtonStyled
        disabled={disabled}
        data-testid="multiSelectButton"
        open={open}
        onClick={() => setOpen(!open)}
      >
        <p>{placeholder}</p>
        <IconWrapperMultiSelectAnimation open={open}>
          <Icon name="arrowDownSpecial" {...(open ? { color: '#0057B8' } : {})} />
        </IconWrapperMultiSelectAnimation>
      </MultiSelectButtonStyled>

      <MultiSelectItemWrapperStyled open={open} {...rest}>
        <MultiSelectBodyItemWrapperStyled>
          {options.map((item) => {
            const label = getOptionLabel ? getOptionLabel(item) : `${item}`;
            const checked = values.includes(item);
            return (
              <MultiSelectItemStyled
                data-testid="multiSelectItem"
                key={getUniqueKey()}
                onClick={() => handleChange(item)}
              >
                <RadioButtonWrapper checked={checked} data-testid="multiSelectItemButton">
                  <RadioButton checked={checked} />
                </RadioButtonWrapper>
                <p>{label}</p>
              </MultiSelectItemStyled>
            );
          })}
          <HandlersMultiSelectWrapper>
            <Button
              variant="ghost"
              size="small"
              onClick={handleCancel}
              data-testid="cancelMultiSelectButton"
            >
              Cancelar
            </Button>
            <Button size="small" onClick={handleApply} data-testid="applyMultiSelectButton">
              Aplicar
            </Button>
          </HandlersMultiSelectWrapper>
        </MultiSelectBodyItemWrapperStyled>
      </MultiSelectItemWrapperStyled>
    </MultiSelectWrapperStyled>
  );
};

MultiSelect.defaultProps = {
  options: [],
  values: [],
  open: false,
  disabled: false,
};

export default MultiSelect;
